import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IAppState } from '@myStore/app.state';
import {
  ActivateESDPFailure,
  ActivateESDPRequest,
  ActivateESDPSuccess,
  AddEsdpMaterialFailure,
  AddEsdpMaterialRequest,
  AddEsdpMaterialSuccess,
  AddHolidaysToESDPTeamFailure,
  AddHolidaysToESDPTeamRequest,
  AddHolidaysToESDPTeamSuccess,
  AddStudentsToESDPTeamFailure,
  AddStudentsToESDPTeamRequest,
  AddStudentsToESDPTeamSuccess,
  AddTeamDocumentsFailure,
  AddTeamDocumentsRequest,
  AddTeamDocumentsSuccess,
  ChangeESDPTeamMentorFailure,
  ChangeESDPTeamMentorRequest,
  ChangeESDPTeamMentorSuccess,
  ChangeRoleToStudentFailure,
  ChangeRoleToStudentRequest,
  ChangeRoleToStudentSuccess,
  CreateESDPTeamIterationFailure,
  CreateESDPTeamIterationRequest,
  CreateESDPTeamIterationSuccess,
  CreateESDPTeamsFailure,
  CreateESDPTeamsRequest,
  CreateESDPTeamsSuccess,
  DeleteESDPTeamIterationFailure,
  DeleteESDPTeamIterationRequest,
  DeleteESDPTeamIterationSuccess,
  DeleteESDPTeamMaterialFailure,
  DeleteESDPTeamMaterialRequest,
  DeleteESDPTeamMaterialSuccess,
  DeleteRoleToStudentFailure,
  DeleteRoleToStudentRequest,
  DeleteRoleToStudentSuccess,
  DeleteStudentFromESDPTeamFailure,
  DeleteStudentFromESDPTeamRequest,
  DeleteStudentFromESDPTeamSuccess,
  DeleteTeamDocumentFailure,
  DeleteTeamDocumentRequest,
  DeleteTeamDocumentSuccess,
  EESDPChangesActions,
  FreeTimeFormRemindLaterFailure,
  FreeTimeFormRemindLaterRequest,
  FreeTimeFormRemindLaterSuccess,
  OpenESDPAccessReviewsFailure,
  OpenESDPAccessReviewsRequest,
  OpenESDPAccessReviewsSuccess,
  ReturnStudentsToESDPTeamFailure,
  ReturnStudentsToESDPTeamRequest,
  ReturnStudentsToESDPTeamSuccess,
  SendFreeTimeGraphFailure,
  SendFreeTimeGraphRequest,
  SendFreeTimeGraphSuccess,
  TransferStudentsToESDPTeamFailure,
  TransferStudentsToESDPTeamRequest,
  TransferStudentsToESDPTeamSuccess,
  UpdateESDPIterationCaptainReportFailure,
  UpdateESDPIterationCaptainReportRequest,
  UpdateESDPIterationCaptainReportSuccess,
  UpdateESDPIterationReviewFailure,
  UpdateESDPIterationReviewRequest,
  UpdateESDPIterationReviewSuccess,
  UpdateESDPIterationRolesFailure,
  UpdateESDPIterationRolesRequest,
  UpdateESDPIterationRolesSuccess,
  UpdateESDPIterationStatusFailure,
  UpdateESDPIterationStatusRequest,
  UpdateESDPIterationStatusSuccess,
  UpdateESDPIterationTimeFailure,
  UpdateESDPIterationTimeRequest,
  UpdateESDPIterationTimeSuccess,
  UpdateESDPTeamFailure,
  UpdateESDPTeamRequest,
  UpdateESDPTeamSuccess,
  UpdateTeamDocumentFailure,
  UpdateTeamDocumentRequest,
  UpdateTeamDocumentSuccess,
} from '@myStore/ESDP-changes/ESDP-changes.actions';
import {
  AddESDPIteration,
  ClearGetESDPTeams,
  DeleteESDPIteration,
  DeleteStudentFromESDPTeam,
  GetESDPIterationByIdRequest,
  GetESDPTeamRequest,
  GetESDPTeamsRequest,
  GetTeamDocumentByIdSuccess,
  GetTeamDocumentsRequest,
  GetTeamMaterialsRequest,
  UpdateESDPIteration,
  UpdateESDPIterationCaptainReport,
  UpdateESDPIterationStatus,
  UpdateESDPIterationStudentsReview,
  UpdateIterationReview,
} from '@myStore/ESDP-view/ESDP.view.actions';
import {
  ClearGetProfile,
  GetProfileRequest,
} from '@myStore/profile-view/profile-view.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ESDPChangesService } from '@services/ESDP-changes/ESDP-changes.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ESDPChangesEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _location: Location,
    private _ESDPChangesService: ESDPChangesService
  ) {}

  $createESDPTeams = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<CreateESDPTeamsRequest>(
          EESDPChangesActions.CreateESDPTeamsRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService.createTeams(action.data).pipe(
            map(team => {
              this._toastr.success(
                'Команды успешно созданы. Выберите команду и создайте для каждой команды итерацию',
                '',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new CreateESDPTeamsSuccess());
              this._router.navigate([
                `/esdp/courses/${team[0].course}/groups/${team[0].group}`,
              ]);
            }),
            catchError(err => {
              if (err.error && err.error[0]?.non_field_errors) {
                this._toastr.error(err.error[0].non_field_errors[0]);
              }
              this._store.dispatch(new CreateESDPTeamsFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $deleteESDPTeams = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteESDPTeamIterationRequest>(
          EESDPChangesActions.DeleteTeamIterationRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .deleteIteration(action.payload.id)
            .pipe(
              map(() => {
                this._store.dispatch(
                  new DeleteESDPIteration(action.payload.id)
                );
                this._store.dispatch(new DeleteESDPTeamIterationSuccess());
                this._toastr.success(
                  `Итерация №${action.payload.number} успешно удалена!`
                );
              }),
              catchError(err => {
                this._toastr.error(err?.error?.detail);
                this._store.dispatch(
                  new DeleteESDPTeamIterationFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $sendFreeTimeGraph = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<SendFreeTimeGraphRequest>(
          EESDPChangesActions.SendFreeTimeGraphRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService.sendFreeTimeGraph(action.data).pipe(
            map(() => {
              this._toastr.success('График занятости успешно записан.', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new SendFreeTimeGraphSuccess());
              this._store.dispatch(new ClearGetProfile());
              this._store.dispatch(new GetProfileRequest(action.userId));
            }),
            catchError(err => {
              let message = 'Что-то пошло не так';
              if (err.error && err.error[0]?.non_field_errors) {
                message = err.error[0].non_field_errors[0];
              }

              if (err.error && err.error.detail) {
                message = err.error.detail;
              }

              this._store.dispatch(new SendFreeTimeGraphFailure(err.error));
              this._toastr.error(message);
              return err.statusText;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $freeTimeRemindLater = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<FreeTimeFormRemindLaterRequest>(
          EESDPChangesActions.FreeTimeFormRemindLaterRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService.freeTimeFormRemindLater().pipe(
            map(() => {
              this._toastr.success('Опрос отложен до завтрашнего дня.', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new FreeTimeFormRemindLaterSuccess());
              this._store.dispatch(new ClearGetProfile());
              this._store.dispatch(new GetProfileRequest(action.studentId));
            }),
            catchError(err => {
              if (err.error && err.error[0]?.non_field_errors) {
                this._toastr.error(err.error[0].non_field_errors[0]);
              }

              this._store.dispatch(
                new FreeTimeFormRemindLaterFailure(err.error)
              );
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $createIterations = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<CreateESDPTeamIterationRequest>(
          EESDPChangesActions.CreateESDPTeamIterationRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService.createIteration(action.payload).pipe(
            map(iteration => {
              this._toastr.success('Итерация успешно создана', '', {
                timeOut: 3500,
              });
              this._store.dispatch(new CreateESDPTeamIterationSuccess());
              this._store.dispatch(new AddESDPIteration(iteration));
            }),
            catchError(err => {
              this._toastr.error(
                `При создании итерации возникла ошибка (post)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(
                new CreateESDPTeamIterationFailure(err.error)
              );
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $updateIterationRoles = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<UpdateESDPIterationRolesRequest>(
          EESDPChangesActions.UpdateRolesIterationRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .updateIterationRoles(action.id, action.payload)
            .pipe(
              map(iteration => {
                this._toastr.success('Роли успешно изменены', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new UpdateESDPIterationRolesSuccess());
                this._store.dispatch(new UpdateESDPIteration(iteration));
              }),
              catchError(err => {
                this._toastr.error(
                  `При обновлении итерации возникла ошибка (put/patch)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new UpdateESDPIterationRolesFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $updateIterationTime = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<UpdateESDPIterationTimeRequest>(
          EESDPChangesActions.UpdateIterationTimeRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .updateIterationTime(action.id, action.payload)
            .pipe(
              map(iteration => {
                this._toastr.success('Время успешно изменено', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new UpdateESDPIterationTimeSuccess());
                this._store.dispatch(new UpdateESDPIteration(iteration));
              }),
              catchError(err => {
                this._toastr.error(
                  `При обновлении времени итерации возникла ошибка (put/patch)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new UpdateESDPIterationTimeFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $deleteStudentFromTeam = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteStudentFromESDPTeamRequest>(
          EESDPChangesActions.DeleteStudentFromTeamRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .deleteStudentFromTeam(action.teamId, action.students)
            .pipe(
              map(() => {
                this._toastr.success('Студент успешно удалён', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new DeleteStudentFromESDPTeamSuccess());
                this._store.dispatch(
                  new DeleteStudentFromESDPTeam(action.students[0])
                );
              }),
              catchError(err => {
                this._toastr.error(
                  `При удалении студента из группы возникла ошибка (delete)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new DeleteStudentFromESDPTeamFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $addStudentsToTeam = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddStudentsToESDPTeamRequest>(
          EESDPChangesActions.AddStudentsToTeamRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .addStudentsToTeam(action.teamId, action.students)
            .pipe(
              map(() => {
                this._toastr.success('Студент(ы) успешно добавлен(ы)', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new AddStudentsToESDPTeamSuccess());
              }),
              catchError(err => {
                this._toastr.error(
                  `При добавлении студента в группу возникла ошибка (post)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new AddStudentsToESDPTeamFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $transferStudentsToTeam = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<TransferStudentsToESDPTeamRequest>(
          EESDPChangesActions.TransferStudentsToTeamRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .transferStudentsToTeam(action.teamId, action.payload)
            .pipe(
              map(() => {
                this._toastr.success('Перевод прошёл успешно', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new TransferStudentsToESDPTeamSuccess());
                this._store.dispatch(new ClearGetESDPTeams());
                if (action.groupId) {
                  this._store.dispatch(
                    new GetESDPTeamsRequest({
                      group: action.groupId,
                    })
                  );
                }

                this._router.navigate([
                  `/esdp/courses/${action.courseId}/groups/${action.groupId}/teams/${action.payload.team}/info`,
                ]);
              }),
              catchError(err => {
                this._toastr.error(
                  `При переводе студента в группу возникла ошибка (post)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new TransferStudentsToESDPTeamFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $returnStudentsToTeam = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ReturnStudentsToESDPTeamRequest>(
          EESDPChangesActions.ReturnStudentsToTeamRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .returnStudentsToTeam(action.teamId, action.students)
            .pipe(
              map(() => {
                this._toastr.success('Студент успешно вернусля в команду', '', {
                  timeOut: 3500,
                });
                this._store.dispatch(new ReturnStudentsToESDPTeamSuccess());
                this._store.dispatch(
                  new DeleteStudentFromESDPTeam(action.students[0])
                );
              }),
              catchError(err => {
                this._toastr.error(
                  `При возврате студента в группу возникла ошибка (patch)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new ReturnStudentsToESDPTeamFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $changeTeamMentor = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ChangeESDPTeamMentorRequest>(
          EESDPChangesActions.ChangeTeamMentorRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .changeTeamMentor(action.teamId, action.mentors)
            .pipe(
              map(() => {
                this._toastr.success(
                  'Изменение ментора команды прошло успешно',
                  '',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new ChangeESDPTeamMentorSuccess());
              }),
              catchError(err => {
                this._toastr.error(
                  `При изминении ментора группы возникла ошибка (patch)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new ChangeESDPTeamMentorFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $addTeamDocument = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddTeamDocumentsRequest>(
          EESDPChangesActions.AddTeamDocumentsRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService.addTeamDocument(action.data).pipe(
            map(() => {
              this._store.dispatch(new AddTeamDocumentsSuccess());
              this._toastr.success('Документ успешно создан', '', {
                timeOut: 3500,
              });
              if (action.teamId) {
                this._store.dispatch(
                  new GetTeamDocumentsRequest({ team_id: action.teamId })
                );
              }
            }),
            catchError(err => {
              this._toastr.error(
                `При добавлении документов в группу возникла ошибка (post)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new AddTeamDocumentsFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $updateTeamDocument = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<UpdateTeamDocumentRequest>(
          EESDPChangesActions.UpdateTeamDocumentRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .updateTeamDocument(action.data, action.id)
            .pipe(
              map(document => {
                this._store.dispatch(new UpdateTeamDocumentSuccess());
                this._store.dispatch(new GetTeamDocumentByIdSuccess(document));
              }),
              catchError(err => {
                this._toastr.error(err?.error?.detail);
                this._store.dispatch(new UpdateTeamDocumentFailure(err.error));
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $deleteTeamDocument = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteTeamDocumentRequest>(
          EESDPChangesActions.DeleteTeamDocumentRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService.deleteTeamDocument(action.id).pipe(
            map(() => {
              this._store.dispatch(new DeleteTeamDocumentSuccess());
            }),
            catchError(err => {
              this._toastr.error(
                `При удалении документов возникла ошибка (delete)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new DeleteTeamDocumentFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $activateESDP = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ActivateESDPRequest>(EESDPChangesActions.ActivateESDPReqeust),
        switchMap(action => {
          return this._ESDPChangesService.activateESDP(action.groupId).pipe(
            map(() => {
              this._toastr.success('ESDP успешно запустилось!');
              this._store.dispatch(new ActivateESDPSuccess());
            }),
            catchError(err => {
              this._toastr.error(
                `При активации ESDP возникла ошибка (post)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new ActivateESDPFailure(err.error));
              return err.statusText;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $updateIterationReview = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<UpdateESDPIterationReviewRequest>(
          EESDPChangesActions.UpdateIterationReviewRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .updateIterationReview(action.id, action.payload)
            .pipe(
              map(review => {
                if (action.payload.is_published) {
                  this._toastr.success('Рецензия успешно опубликована!');
                }

                this._store.dispatch(new UpdateESDPIterationReviewSuccess());

                if (action.payload.currentId) {
                  this._store.dispatch(
                    new UpdateESDPIterationStudentsReview(review)
                  );
                } else {
                  this._store.dispatch(new UpdateIterationReview(review));
                }
              }),
              catchError(err => {
                const { points, is_published, text } = err.error;
                let message = 'Что-то пошло не так';

                if (points) {
                  message = points[0];
                }

                if (is_published) {
                  message = is_published[0];
                }

                if (text) {
                  message = text[0];
                }

                this._toastr.error(message);
                this._store.dispatch(
                  new UpdateESDPIterationReviewFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $updateIterationCaptainReport = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<UpdateESDPIterationCaptainReportRequest>(
          EESDPChangesActions.UpdateIterationCaptainReportRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .updateIterationCaptainReports(action.id, action.payload)
            .pipe(
              map(reports => {
                this._toastr.success('Отчёт успешно сохранён!!');
                this._store.dispatch(
                  new UpdateESDPIterationCaptainReportSuccess()
                );
                this._store.dispatch(
                  new GetESDPIterationByIdRequest(action.id)
                );
                setTimeout(() => {
                  this._store.dispatch(
                    new UpdateESDPIterationCaptainReport(
                      action.indexCurrentDay,
                      reports[0]
                    )
                  );
                }, 225);
              }),
              catchError(err => {
                this._toastr.error(
                  `При обноалении рапорта возникла ошибка (put)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new UpdateESDPIterationCaptainReportFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $updateIterationStatus = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<UpdateESDPIterationStatusRequest>(
          EESDPChangesActions.UpdateIterationStatusRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .updateIterationStatus(action.id, action.payload)
            .pipe(
              map(() => {
                let message = 'Доступ успешно закрыт!';

                if (action.payload.is_active) {
                  message = 'Доступ успешно открыт!';
                }
                this._toastr.success(message);
                this._store.dispatch(new UpdateESDPIterationStatusSuccess());
                this._store.dispatch(
                  new UpdateESDPIterationStatus(action.payload.is_active)
                );
              }),
              catchError(err => {
                this._toastr.error(
                  `При обновлении статуса итерации возникла ошибка (patch)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new UpdateESDPIterationStatusFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $openAccessReviews = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<OpenESDPAccessReviewsRequest>(
          EESDPChangesActions.OpenAccessReviewsRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .openAccessReviews(action.groupId)
            .pipe(
              map(() => {
                this._toastr.success('Доступ успешно открыт!');
                this._store.dispatch(new OpenESDPAccessReviewsSuccess());
              }),
              catchError(err => {
                this._toastr.error(
                  `При открытии доступа возникла ошибка (post)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new OpenESDPAccessReviewsFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $addHolidaysToTeam = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddHolidaysToESDPTeamRequest>(
          EESDPChangesActions.AddHolidaysToTeamRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .addHolidaysToTeam(action.payload)
            .pipe(
              map(() => {
                this._toastr.success('Каникулы успешно добавлены!');
                this._store.dispatch(new AddHolidaysToESDPTeamSuccess());
              }),
              catchError(err => {
                this._store.dispatch(
                  new AddHolidaysToESDPTeamFailure(err.error)
                );

                if (err.error.team) {
                  this._toastr.error(`${err.error.team}!`, '', {
                    timeOut: 5000,
                  });
                }
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $updateTeam = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<UpdateESDPTeamRequest>(EESDPChangesActions.UpdateTeamRequest),
        switchMap(action => {
          return this._ESDPChangesService
            .updateTeam(action.teamId, action.data)
            .pipe(
              map(() => {
                if (!action.data.is_active) {
                  this._toastr.success('Команда успешно добавлена в архив!');
                  this._store.dispatch(new ClearGetESDPTeams());
                  this._router.navigate([this._router.url.split('teams')[0]]);
                }

                this._store.dispatch(new UpdateESDPTeamSuccess());
              }),
              catchError(err => {
                let message = 'Что-то пошло не так';

                if (err.error && err.error.detail) {
                  message = err.error.detail;
                }

                this._toastr.error(message);
                this._store.dispatch(new UpdateESDPTeamFailure());
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $addTeamMaterial = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<AddEsdpMaterialRequest>(
          EESDPChangesActions.AddEsdpMaterialRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .addTeamMaterial(action.file, action.teamId)
            .pipe(
              map(() => {
                this._store.dispatch(new AddEsdpMaterialSuccess());
                this._toastr.success('Файл успешно добавлен', '', {
                  timeOut: 3500,
                });
                if (action.teamId) {
                  this._store.dispatch(
                    new GetTeamMaterialsRequest(action.teamId)
                  );
                }
              }),
              catchError(err => {
                this._toastr.error(
                  `При добавлении файла возникла ошибка (post)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new AddEsdpMaterialFailure(err.error));
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $deleteTeamMaterial = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteESDPTeamMaterialRequest>(
          EESDPChangesActions.DeleteTeamMaterialRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .deleteTeamMaterial(action.id, action.fileId)
            .pipe(
              map(() => {
                this._store.dispatch(new DeleteESDPTeamMaterialSuccess());
              }),
              catchError(err => {
                this._toastr.error(
                  `При удалении материала группы возникла ошибка (delete)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new DeleteESDPTeamMaterialFailure(err.error)
                );
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $changeRole = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ChangeRoleToStudentRequest>(
          EESDPChangesActions.ChangeRoleToStudentRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .changeRoleToStudent(
              action.teamId,
              action.student_id,
              action.assigned_role
            )
            .pipe(
              map(() => {
                this._store.dispatch(new ChangeRoleToStudentSuccess());
                this._toastr.success('Роль успешно закреплена', '', {
                  timeOut: 3500,
                });
                if (action.teamId) {
                  this._store.dispatch(new GetESDPTeamRequest(action.teamId));
                }
              }),
              catchError(err => {
                this._toastr.error(
                  `При закреплении роли возникла ошибка (post)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new ChangeRoleToStudentFailure(err.error));
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $deleteRole = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteRoleToStudentRequest>(
          EESDPChangesActions.DeleteRoleToStudentRequest
        ),
        switchMap(action => {
          return this._ESDPChangesService
            .deleteRoleToStudent(action.teamId, action.student, action.role)
            .pipe(
              map(() => {
                this._store.dispatch(new DeleteRoleToStudentSuccess());
                this._toastr.success('Роль успешно удалена', '', {
                  timeOut: 3500,
                });
              }),
              catchError(err => {
                this._toastr.error(
                  `При удалении роли возникла ошибка (post)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new DeleteRoleToStudentFailure(err.error));
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );
}
